import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=b21ee06c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b21ee06c')) {
      api.createRecord('b21ee06c', component.options)
    } else {
      api.reload('b21ee06c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=b21ee06c&", function () {
      api.rerender('b21ee06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fQpMCTFzENTF/JS/comp/ImgFallback.vue"
export default component.exports